import { gql } from '@apollo/client'

export const RESET_PASSWORD_BY_TOKEN_MUTATION = gql`
  mutation ResetPasswordByTokenMutation(
    $newPassword: String!
    $token: String!
  ) {
    resetPasswordByToken(token: $token, newPassword: $newPassword) {
      ok
      loginToken
    }
  }
`

export const CREATE_PASSWORD_BY_TOKEN_MUTATION = gql`
  mutation CreatePasswordByTokenMutation(
    $newPassword: String!
    $token: String!
  ) {
    createPasswordByToken(token: $token, newPassword: $newPassword) {
      ok
      loginToken
    }
  }
`

export const RESPOND_TO_COMPANY_INVITATION_MUTATION = gql`
  mutation RespondToCompanyInvitationMutation(
    $token: String!
    $accept: Boolean!
  ) {
    respondToCompanyInvitation(token: $token, accept: $accept) {
      ok
      companyName
    }
  }
`
